export interface INameGroupEmptyValidatable {
  name: string;
  enableNameGroupEmptyCheck: boolean;
  isEmpty: boolean; /* チェック・円選択は単体で空かどうかを見ても判定できないので注意すること */
  enableEmptyCheckConfirmation: boolean;
}

export function instanceOfINameGroupEmptyValidatable(instance: any): instance is INameGroupEmptyValidatable {
  return instance
    && (instance.name !== undefined
    && instance.enableNameGroupEmptyCheck !== undefined
    && instance.isEmpty !== undefined);
}
